import { useEffect } from 'react';

import { useUserLocation as useUserLocationGarnish } from '@sg/garnish';

import { useTelemetry } from '@order/Telemetry';

/**
 * Wrapper around garnish's useUserLocation.
 * Pipes the resolved geolocation coordinates into the Mixpanel customer profile.
 */
export const useUserLocation = (
  options: Parameters<typeof useUserLocationGarnish>[0],
): ReturnType<typeof useUserLocationGarnish> => {
  const { setCustomerProperty } = useTelemetry();

  const userLocationResult = useUserLocationGarnish(options);
  const lat = userLocationResult.geolocation?.latitude ?? 0;
  const lng = userLocationResult.geolocation?.longitude ?? 0;
  const hasUserLocation = lat !== 0 && lng !== 0;

  useEffect(() => {
    if (hasUserLocation) {
      setCustomerProperty?.('lat', lat);
      setCustomerProperty?.('lng', lng);
    }
  }, [hasUserLocation, lat, lng, setCustomerProperty]);

  return userLocationResult;
};
